<template>
  <div>
    <img class="title" :src="info.topImgUrl" alt="" />
    <div class="imgpath flex-js-ac flex-w">
      <div class="pos-r w-50" v-for="(item, index) of info.goodsList" :key="index">
        <img
          class="of-c w-100"
          :src="item.imgUrl"
          alt=""
          @click="bannerClick(item, index, 'ITEMSHF')"
        />
        <div
          :path="item.adTarget + (item.adTarget.indexOf('?') >= 0 ? '&' : '?') + 'sorce=15'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.adType == 7 || item.adType == 8)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { bannerClick, isWeixin } from '../../../assets/common/js/config'
export default {
  name: 'actGoodsAd',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isWx: isWeixin() ? 1 : 0
    }
  },
  mounted() {},
  methods: {
    bannerClick(items, index, flowArea) {
      let info = {
        ad_type: items.adType,
        ad_target: items.adTarget,
        ad_title: items.adtitle,
        ...items
      }
      bannerClick(info, index, flowArea, this)
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  width: 100%;
}
.imgpath img {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actGoodsAd.vue